import React, { useState } from "react"
import useSWRInfinite from "swr/infinite"
import { getGameBets } from "../../services/games"
import InfiniteScroll from "react-infinite-scroll-component"
import { formatEtherscanLink, shortenHex, toTitleCase } from "../../utils/string"
import clsx from "clsx"
import { useTranslation } from "next-i18next"
import useGlobalStore from "../../hooks/useGlobalStore"
import { formatDate } from "../../utils/date"
import { nFormatter } from "../../utils/number"

export const GameBets = (props) => {
    const { t: tGameDetails } = useTranslation("game-details")
    const { isLoggedIn, account } = useGlobalStore()

    const { game, mode } = props
    const { id, chainId } = game

    const [gameFrom, setGameFrom] = useState("OTHERS")

    const getKey = (pageIndex, previousData) => {
        if (!id || (!isLoggedIn && gameFrom === "MY")) {
            return null
        }

        const paginator = previousData && previousData.paginator
        if (paginator && !paginator.hasNextPage) {
            return null
        }

        return ["GAME_BETS", gameFrom, pageIndex + 1, id]
    }

    const fetcher = async (key, from, page) => {
        const response = await getGameBets(id, from, page)

        return response.data.data
    }

    const {
        data: gameList,
        error,
        size,
        setSize
    } = useSWRInfinite(getKey, fetcher, {
        revalidateFirstPage: true,
        refreshInterval: 10000
    })

    const isLoading = !gameList && !error
    const isLoadingMore = isLoading || (size > 0 && gameList && gameList[gameList.length - 1].paginator.hasNextPage)
    const totalItems = gameList ? gameList.reduce((previousValue, game) => previousValue + game.list.length, 0) : 0

    return (
        <div>
            <div className={"relative ml-2 mb-[-2px] flex gap-1 text-12 font-medium"}>
                <div
                    onClick={() => setGameFrom("OTHERS")}
                    className={clsx(
                        "cursor-pointer border-b-2 border-transparent px-[15px] py-[5px] leading-[15px] hover-active:border-primary hover-active:font-bold",
                        gameFrom === "OTHERS" && "active"
                    )}
                >
                    {tGameDetails("others")}
                </div>
                <div
                    onClick={() => setGameFrom("MY")}
                    className={clsx(
                        "cursor-pointer border-b-2 border-transparent px-[15px] py-[5px] leading-[15px] hover-active:border-primary hover-active:font-bold",
                        gameFrom === "MY" && "active"
                    )}
                >
                    {tGameDetails("myLog")}
                </div>
            </div>
            <div className={"h-[302px] w-full rounded-[5px] bg-[#E8E8E8]"}>
                <div className={"mx-[6px] pt-[6px]"}>
                    <div
                        className={
                            "flex h-[46px] items-center justify-between rounded-[5px_5px_0_0] bg-neutral-1-900 px-5 text-12 leading-[15px] text-neutral-1-100"
                        }
                    >
                        <div className={"flex-[0_0_38%]"}>{tGameDetails("gameBets.id")}</div>
                        <div className={"flex-1"}>{tGameDetails("gameBets.betting")}</div>
                        <div className={"flex-[0_0_60px]"}>{tGameDetails("gameBets.time")}</div>
                    </div>
                    <div
                        className={"b-scrollbar beer dark max-h-[240px] overflow-y-auto overflow-x-hidden text-10"}
                        id={`game-bets-scroll-${mode}`}
                    >
                        <InfiniteScroll
                            dataLength={totalItems}
                            next={() => setSize(size + 1)}
                            hasMore={isLoadingMore}
                            loader={""}
                            scrollableTarget={`game-bets-scroll-${mode}`}
                        >
                            {gameList &&
                                gameList.map((games, index0) => {
                                    return games.list.map((game, index) => {
                                        const {
                                            transactionHash,
                                            walletAddress,
                                            amount,
                                            choice,
                                            choiceName,
                                            tokenName,
                                            createdAt
                                        } = game

                                        return (
                                            <div
                                                key={`${transactionHash}_${index0}_${index}`}
                                                className={clsx(
                                                    "flex h-[30px] items-center justify-between px-5 leading-4",
                                                    index % 2 === 0
                                                        ? "bg-[rgba(255,255,255,0.3)]"
                                                        : "bg-rgba(5,5,15,0.1)"
                                                )}
                                            >
                                                <div className={"flex-[0_0_38%]"}>
                                                    <a
                                                        rel={"noreferrer"}
                                                        href={formatEtherscanLink("Transaction", [
                                                            chainId,
                                                            transactionHash
                                                        ])}
                                                        target={"_blank"}
                                                        className={"text-accent-4 hover:text-primary"}
                                                    >
                                                        {shortenHex(walletAddress)}
                                                    </a>
                                                </div>
                                                <div className={"flex-1 font-semibold"}>
                                                    <span>
                                                        {nFormatter(amount, 3)} {tokenName} |{" "}
                                                    </span>
                                                    <span
                                                        className={clsx(
                                                            "uppercase",
                                                            choice === 1 ? "text-primary" : "text-accent-4"
                                                        )}
                                                    >
                                                        {toTitleCase(choiceName)}
                                                    </span>
                                                </div>
                                                <div className={"flex-[0_0_60px]"}>
                                                    {formatDate(createdAt, "MM/DD/YYYY")}
                                                </div>
                                            </div>
                                        )
                                    })
                                })}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        </div>
    )
}
